// exclude-from-index
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider, StyledEngineProvider, createTheme } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';
import MuiSwitch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import { cloneDeep } from 'lodash';
import { muiGlobalTheme } from '@themes';
import { overrideSwitchStyles } from './Switch.styles';
import { Label } from '../Label';
import { WithStylesClassesPropType } from '../../../../lib/commonPropTypes';

const customizeMuiGlobalTheme = () => {
  const newSwitchTheme = cloneDeep(muiGlobalTheme);
  newSwitchTheme.components = {
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          marginLeft: 0,
          alignItems: 'flex-start'
        }
      }
    }
  };
  return createTheme(newSwitchTheme);
};

function Switch(props) {
  const { label, classes, description, toolTip, ...other } = props;

  const switchTheme = useRef(customizeMuiGlobalTheme());

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={switchTheme.current}>
        <FormControlLabel
          control={<MuiSwitch {...other} color="primary" classes={classes} />}
          label={<Label label={label} description={description} toolTip={toolTip} />}
        />
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

Switch.propTypes = {
  /** Optional title that appears above label  */
  description: PropTypes.string,
  /** Optional prop for passing tooltip component  */
  toolTip: PropTypes.node,

  id: PropTypes.string,
  name: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,

  label: PropTypes.string,
  classes: WithStylesClassesPropType.isRequired
};

Switch.defaultProps = {
  description: undefined,
  toolTip: null,
  id: '',
  name: '',
  checked: false,
  onChange: () => {},
  disabled: false,
  label: ''
};

const ComposedSwitch = withStyles(overrideSwitchStyles)(Switch);
export default ComposedSwitch;
